import React from 'react';

const Requisites = () => {
  return (
    <div style={styles.container}>
      <h2>Реквизиты</h2>
      <p><strong>ИП</strong> Гладков Андрей Петрович</p>
      <p><strong>ОГРНИП:</strong> 304233013800258</p>
      <p><strong>ИНН:</strong> 233001711409</p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '20px auto',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '10px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f9f9f9',
  },
};

export default Requisites;
